function strlToggleScrollToTop(scrollHeight = 40) {
		const scrollToTopEl = document.getElementById('scroll-to-top');
		if ( window.scrollY > scrollHeight ) {
				scrollToTopEl.classList.add('visible');
		} else {
				scrollToTopEl.classList.remove('visible');
		}
}

document.addEventListener('DOMContentLoaded', () => {
		const scrollToTopEl = document.getElementById('scroll-to-top');
		strlToggleScrollToTop();
		scrollToTopEl.addEventListener('click', () => {
				window.scrollTo(0, 0);
		});
});

window.addEventListener('scroll', () => strlToggleScrollToTop());